import React, { useRef, useContext, useState, useEffect } from 'react'
import { Field, Formik, Form } from 'formik';

import * as yup from 'yup';
import { ValidationError } from '../Errors/ValidationError';
import { LeadsContext } from '../Context/LeadsContext';
import { getImages } from '../Const';
import CustomRadio from '../Common/CustomRadio';
import CustomAutoSearch from '../Common/CustomAutoSearch';
import PhoneSearch from './PhoneSearch';
const bankList = [
  { id: 1, title: "Wells Fargo Auto" },
  { id: 2, title: "Chase" },
  { id: 3, title: "Bank of America" },
  { id: 4, title: "PNC" },
  { id: 5, title: "Space Coast Credit Union" }
];
const colorList = [
  { id: 1, title: "White" },
  { id: 2, title: "Black" },
  { id: 3, title: "Gray" },
  { id: 4, title: "Silver" },
  { id: 5, title: "Red" },
  { id: 6, title: "Blue" },
  { id: 7, title: "Green" },
  { id: 8, title: "Brown" },
  { id: 9, title: "Orange" },
  { id: 10, title: "Other" },
];
const NewAppraisalModal = ({ close, appraisalStage, leadType }) => {

  const { addLead, decodeVIN, validateVIN, vehicleListSearch, getLeadData, migrateWebLead, selectLead, leadsLoading, priceFormatter, defaultYears } = useContext(LeadsContext);  

  const [vehicleYears, setVehicleYears] = useState([]);
  const [vehicleMakes, setVehicleMakes] = useState([]);
  const [vehicleModels, setVehicleModels] = useState([]);
  const [vehicleTrims, setVehicleTrims] = useState([]);

  const [vehicleYearData, setVehicleYearData] = useState([]);

  const [autoSearchReset,setAutoSearchReset] = useState(0);

  useEffect(() => {

    setVehicleYears(defaultYears);
  }, [defaultYears]);

  const getVehicleYearData = async (year) => {
      if(String(year).length != 4) return;
      const data = await vehicleListSearch({ 'subject': 'yeardata', 'year': year });
      //console.log(data);

      setVehicleYearData(data);

      let makes = [];

      if ('makes' in data) {
          data['makes'].map((make, i) => {
              makes.push(make.name);
          });

          setVehicleMakes(makes);
      }
  }

  const getVehicleModels = async (make) => {
      //console.log(formikRef.current.values.year, make);

      if ('makes' in vehicleYearData) {

          let models = [];

          vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
              console.log(make);
              if ('models' in make) {
                  make['models'].map((model, j) => {
                      models.push(model.name);
                  })
              }
          });

          setVehicleModels(models);
      }
  }

  const getVehicleTrims = async (model) => {
      //console.log(year, make, model);
      const make = formikRef.current.values.make;

      if ('makes' in vehicleYearData) {

          let trims = [];

          vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
              //console.log(make);
              if ('models' in make) {
                  make['models'].filter((item) => item.name == model).map((model, j) => {
                      if ('trims' in model) {
                          model['trims'].map((trim, k) => {
                              trims.push(trim.name);
                          })
                      }
                  })
              }
          });

          setVehicleTrims(trims);
      }
  }

  const validationSchemaStep1 = yup.object({
    vin: yup.string().test(
      "valid-vin",
      "Please enter a valid VIN.",
      (value) => !value || value == "" || validateVIN(value)
    ),
  });

  const formikRef = useRef(null);

  const handleSubmit = async (values, resetForm) => {
    if(values.existing_lead && addSelectedItem && 'web_lead' in addSelectedItem) values.web_lead = addSelectedItem.web_lead;

    const data = values.existing_lead ? await migrateWebLead(values) : await addLead(values);

    if (data && data.success) {
      close();
      alert("Lead added");
      if(values.existing_lead) selectLead(values.lead_id);
      resetForm();
      setAddSelectedItem({});
    } else {
      alert("Error adding lead");
    }
  }

  const doDecodeVIN = async (values, setFieldValue) => {
    console.log(values);

    if (values.vin && validateVIN(values.vin)) {
      var decode_data = await decodeVIN(values.vin);

      console.log(decode_data);

      if (decode_data.year) {
          setVehicleYears([decode_data.year]);
          setFieldValue("year", decode_data.year);
      }

      if (decode_data.make) {
          setVehicleMakes([decode_data.make]);
          setFieldValue("make", decode_data.make);
      }

      if (decode_data.model) {
          setVehicleModels([decode_data.model]);
          setFieldValue("model", decode_data.model);
      }

      if (decode_data.trims && decode_data.trims.length > 0) {
          setVehicleTrims([decode_data.trims[0].name]);
          setFieldValue("trim", decode_data.trims[0].name);
      }
    } else
      alert("Please enter a valid VIN");
  }

  const [selectedLeads, setSelectedLeads] = useState([]);
  const [addSelectedItem, setAddSelectedItem] = useState({});
  const addAppraisalDtl = async (addItem) => {
    const leadData = await getLeadData(addItem.id);

    setAddSelectedItem({...leadData,...{
      first_name: addSelectedItem.first_name || "",
      last_name: addSelectedItem.last_name || "",
      email: addSelectedItem.email || "",
      phone: addSelectedItem.phone || "",
      company: addSelectedItem.company || "",
      existing_lead: true,
      lead_id: addItem.id,
      web_lead: addItem.web
    }})
  }

  const titleStatusEnabled = ['Financed', 'Lease'];

  const activePage = window.location.pathname.includes('/store') ? "/store" : "/web";

  return (
    <>
      <div className="modal-content">
        <Formik
          initialValues={{
            location: 'BOYNTON BEACH',
            type: 'In Person',
            first_name: addSelectedItem.first_name || "",
            last_name: addSelectedItem.last_name || "",
            email: addSelectedItem.email || "",
            phone: addSelectedItem.phone || "",
            company: addSelectedItem.company || "",
            notes: "",
            vin: addSelectedItem.vin || "",
            year: addSelectedItem.year || "",
            make: addSelectedItem.make || "",
            model: addSelectedItem.model || "",
            trim: addSelectedItem && 'trim' in addSelectedItem ? addSelectedItem['trim'] : "",
            mileage: addSelectedItem.mileage || "",
            color: addSelectedItem.color || "",
            vehicle_condition: addSelectedItem.vehicle_condition || "",
            vehicle_keys: addSelectedItem.vehicle_keys || "yes",
            books: addSelectedItem.books || "yes",
            finance: "Paid",
            titlestatus: addSelectedItem.titlestatus || "Good",
            appraisal_stage: appraisalStage || "",
            lead_type: leadType || "",
            lender: addSelectedItem.lender || "",
            existing_lead: addSelectedItem.existing_lead || false,
            lead_id: addSelectedItem.lead_id || ""
          }}
          validationSchema={validationSchemaStep1}
          onSubmit={(values, { resetForm }) => {
            console.log(values);
            setVehicleYears(defaultYears);   
            setAutoSearchReset((prev) => prev + 1);
            resetForm();
            handleSubmit(values, resetForm);
          }}
          enableReinitialize={true}
          innerRef={formikRef}
        >
          {({ values, setFieldValue }) => (
            <>
              <Form className='custom-form appraisal-form'>
                <div className="modal-header">
                  <h1 className="modal-title text-uppercase text-center w-100" id="staticBackdropLabel">
                    New Appraisal
                  </h1>
                  <button className="sm-box-close" type="button" onClick={close}>
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
                <div className="modal-body white-bg">
                  <div className="accordion autopilot-accordion appraisal-accordion" id="accordionExample">
                    <div className="accordion-item mb-2">
                      <h2 className="accordion-header" id="headingOne">
                        <button className="accordion-button d-flex align-itmes-center justify-content-between w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          1. Customer Info
                        </button>
                      </h2>
                      <div id="collapseOne" className={`accordion-collapse collapse show`} aria-labelledby="headingOne">
                        <div className="accordion-body">
                          <div className='p-0'>
                            <div className='row'>
                              <div className='form-group col-md-6'>
                                <label>Location</label>
                                  {/*<CustomRadio id="boyntonRadio" name="location" value="BOYNTON BEACH" label="Boynton" />
                                  <CustomRadio id="pompanoBeachRadio" name="location" value="POMPANO BEACH" label="Pompano Beach" />*/}
                                <div className='d-flex align-items-center nam-flex'>
                                  <div className={`nam-chkbox ${values.location === "BOYNTON BEACH" ? 'active' : ''}`}>
                                    <Field className="me-1 align-middle ab-checkbox" name="location" type="radio" value="BOYNTON BEACH" id="boyntonRadio"/>
                                    <label htmlFor="boyntonRadio">Boynton&nbsp;&nbsp;</label>
                                  </div>
                                  <div className={`nam-chkbox ${values.location === "POMPANO BEACH" ? 'active' : ''}`}>
                                    <Field className="me-1 align-middle ab-checkbox" name="location" type="radio" value="POMPANO BEACH" id="pompanoBeachRadio" />
                                    <label htmlFor="pompanoBeachRadio">Pompano&nbsp;&nbsp;</label>
                                  </div>
                                </div>
                              </div>
                              <div className='form-group col-md-6'>
                                <label>Type</label>
                                  {/*<CustomRadio id="inPersonRadio" name="type" value="In Person" label="In Person" />
                                  <CustomRadio id="phoneCallRadio" name="type" value="Phone Call" label="Phone Call" />*/}
                                <div className='d-flex align-items-center nam-flex'>
                                  <div className={`nam-chkbox ${values.type === "In Person" ? 'active' : ''}`}>
                                    <Field className="me-1 align-middle ab-checkbox" name="type" type="radio" value="In Person" id="inPersonRadio"/>
                                    <label htmlFor="inPersonRadio">In Person&nbsp;&nbsp;</label>
                                  </div>
                                  <div className={`nam-chkbox ${values.type === "Phone Call" ? 'active' : ''}`}>
                                    <Field className="me-1 align-middle ab-checkbox" name="type" type="radio" value="Phone Call" id="phoneCallRadio" />
                                    <label htmlFor="phoneCallRadio">Phone Call&nbsp;&nbsp;</label>
                                  </div>
                                </div>
                              </div>
                              <div className='form-group col-md-6'>
                                <label>First Name</label>
                                <Field name="first_name" type="text" className='form-control' />
                              </div>
                              <div className='form-group col-md-6'>
                                <label>Last Name</label>
                                <Field name="last_name" type="text" className='form-control' />
                              </div>
                              <div className='form-group col-md-6'>
                                <label>Phone</label>
                                <Field name="phone" type="hidden" className='form-control' />
                                <PhoneSearch setSelectedLeads={setSelectedLeads} setAddSelectedItem={setAddSelectedItem} formikRef={formikRef}/>
                              </div>
                              <div className='form-group col-md-6'>
                                <label>Email</label>
                                <Field name="email" type="text" className='form-control' />
                              </div>
                              <div className='form-group col-md-6'>
                                <label>Company</label>
                                <Field name="company" type="text" className='form-control' />
                              </div>
                              <div className='form-group col-md-6'>
                                <label>Notes</label>
                                <Field name="notes" type="text" className='form-control' />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {selectedLeads && selectedLeads.length > 0 && 
                      <div className='pt-4 pb-5 px-5'>
                        <div className='xs-title text-dblue font-1em mb-3'>Previous Appraisals</div>
                        <div className='pa-custom-table'>
                          <table className='w-100'>
                            <tbody>
                              {selectedLeads.map((lead,i) => {
                              return (
                                <tr key={i}>
                                  <td>{lead.web ? "WEB LEAD - " : ""}{lead.vehicle_name}</td>
                                  <td>{lead.appraisal && lead.appraisal > 0 && <><span className='text-dblue'>{priceFormatter(lead.appraisal,true)}</span> appraisal</>}</td>
                                  <td>{lead.expiration_date ? lead.expiration_date.split("T")[0] + " exp" : ""}</td>
                                  <td className='text-end'>
                                    <button type="button" onClick={()=>window.open(`${activePage}?lead_id=${lead.id}`, '_blank')} className='text-dblue text-uppercase oa-link fw-700'>
                                      <img src={getImages('external-link.png')} /> Open Appraisal
                                    </button>
                                  </td>
                                  <td className='text-end'>
                                    <button type="button" onClick={()=>addAppraisalDtl(lead)} className='blue-btn sm-btn text-uppercase py-2'><span className='add-icon'></span> Add</button>
                                  </td>
                                  {/*<td className='text-end'>
                                    {lead.web == 1 && !leadsLoading && <button type="button" onClick={()=>migrateLead(lead.id)} className='blue-btn sm-btn text-uppercase py-2'><span className='add-icon'></span> Submit</button>}
                                  </td>*/}
                                </tr>
                              )})}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }
                    <div className="accordion-item mb-2">
                      <h2 className="accordion-header" id="headingTwo">
                        <button className="accordion-button d-flex align-itmes-center justify-content-between w-100" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                          2. Vehicle Info
                        </button>
                      </h2>
                      <div id="collapseTwo" className={`accordion-collapse collapse show`} aria-labelledby="headingTwo">
                        <div className="accordion-body">
                          <div className='p-0 appraisal-step2'>
                            <div className='row'>
                              <div className='form-group col-12'>
                                <div className='row mlr-17'>
                                  <div className='col-6'>
                                    <div className={`vin-box d-flex align-items-center selected`}>
                                      <div className='position-relative vin-box-left'>
                                        <Field type='text' name="vin"
                                          className='form-control text-uppercase'
                                          placeholder="Enter VIN"
                                          onChange={(e) => {setFieldValue("vin",e.target.value.toUpperCase())}}
                                        />
                                      </div>
                                      <button className='enter-btn text-uppercase' onClick={() => { doDecodeVIN(values, setFieldValue) }} type="button"><img src={getImages('white-check-icon.svg')} /></button>
                                    </div>
                                    <ValidationError name="vin" />
                                  </div>
                                </div>
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Year</label>                                
                                <Field name="year" type="hidden" /> 
                                <CustomAutoSearch 
                                  filteredList={vehicleYears.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                  fieldName={"year"} 
                                  setFieldValue={setFieldValue} 
                                  initialValue={values.year}
                                  doOnChange={getVehicleYearData}
                                  resetValue={autoSearchReset}
                                />
                                {/*<Field name="year" className='form-control'></Field>
                                <Field
                                    name="year"
                                    as="select"
                                    className='form-control'
                                    onChange={(e) => { setFieldValue('year', e.target.value); getVehicleYearData(e.target.value); }}
                                >
                                    <option value=''>
                                        Select
                                    </option>
                                    {vehicleYears.map((v, i) => (
                                        <option key={i} value={v}>
                                            {v}
                                        </option>
                                    ))}
                                </Field>*/}                        
                                <ValidationError name="year" />
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Make</label>
                                <Field name="make" type="hidden" />
                                <CustomAutoSearch 
                                  filteredList={vehicleMakes.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                  fieldName={"make"} 
                                  setFieldValue={setFieldValue} 
                                  initialValue={values.make}
                                  doOnChange={getVehicleModels}
                                  resetValue={autoSearchReset}
                                />
                                {/*<Field name="make" className='form-control' onChange={(e) => {setFieldValue("make",e.target.value.toUpperCase())}}></Field>
                                <Field
                                    as="select"
                                    name="make"
                                    className="form-control"
                                    onChange={(e) => { setFieldValue('make', e.target.value); getVehicleModels(e.target.value); }}
                                >
                                    <option value=''>
                                        Select
                                    </option>
                                    {vehicleMakes.map((v, i) => (
                                        <option key={i} value={v}>
                                            {v}
                                        </option>
                                    ))}
                                </Field>*/}
                                <ValidationError name="Make" />
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Model</label>
                                <Field name="model" type="hidden" />
                                <CustomAutoSearch 
                                  filteredList={vehicleModels.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                  fieldName={"model"} 
                                  setFieldValue={setFieldValue} 
                                  initialValue={values.model}
                                  doOnChange={getVehicleTrims}
                                  resetValue={autoSearchReset}
                                />
                                {/*<Field name="model" className='form-control'></Field>
                                <Field
                                    as="select"
                                    name="model"
                                    className="form-control"
                                    onChange={(e) => { setFieldValue('model', e.target.value); getVehicleTrims(e.target.value); }}
                                >
                                    <option value=''>
                                        Select
                                    </option>
                                    {vehicleModels.map((v, i) => (
                                        <option key={i} value={v}>
                                            {v}
                                        </option>
                                    ))}
                                </Field>*/}
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Trim</label>
                                <Field name="trim" type="hidden" />
                                <CustomAutoSearch 
                                  filteredList={vehicleTrims.map((v,i) => {return {"id":i,"title":v.toString()}})} 
                                  fieldName={"trim"} 
                                  setFieldValue={setFieldValue} 
                                  initialValue={values.trim}
                                  resetValue={autoSearchReset}
                                />
                                {/*<Field name="trim" className='form-control'></Field>
                                <Field
                                    as="select"
                                    name="trim"
                                    className="form-control"
                                    onChange={(e) => { setFieldValue('trim', e.target.value); }}
                                >
                                    <option value=''>
                                        Select
                                    </option>
                                    {vehicleTrims.map((v, i) => (
                                        <option key={i} value={v}>
                                            {v}
                                        </option>
                                    ))}
                                </Field>*/}
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Miles</label>
                                <Field name="mileage" className='form-control'>
                                </Field>
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Color</label>
                                <Field name="color" type="hidden">
                                </Field> 
                                <CustomAutoSearch filteredList={colorList} fieldName={"color"} setFieldValue={setFieldValue} resetValue={autoSearchReset}/>
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Condition</label>
                                <Field name="vehicle_condition" className='form-control'>
                                </Field>
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Keys</label>
                                <Field as="select" name="vehicle_keys" className='form-control'>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                </Field>
                              </div>
                              <div className='form-group col-md-3'>
                                <label>Books</label>
                                <Field as="select" name="books" className='form-control'>
                                  <option value="yes">Yes</option>
                                  <option value="no">No</option>
                                </Field>
                              </div>
                              {/* <div className='form-group col-md-3'>
                                <label>Finance</label>
                                <Field as="select" name="finance" className='form-control'>
                                  <option value="Paid">Paid</option>
                                  <option value="Loan">Loan</option>
                                  <option value="Lease">Lease</option>
                                </Field>
                              </div>
                              <div className='form-group col-md-6'>
                                <label>Title Status</label>
                                <Field as="select" name="titlestatus" placeholder="Title Status" className='form-control' >
                                  <option value="Good">Good</option>
                                  <option value="Bad">Bad</option>
                                </Field>
                              </div> */}
                              <div className='form-group col-md-3'>
                                <div className='adr-label mb-1'>Title Status</div>
                                <Field name="titlestatus" as="select" className='form-control' onChange={(e) => {setFieldValue("titlestatus",e.target.value); setFieldValue("lender",titleStatusEnabled.includes(e.target.value) ? values.lender : "");}}>
                                  <option value="">Select</option>
                                  <option value="Paper Title">Paper Title</option>
                                  <option value="E-Title">E-Title</option>
                                  <option value="Financed">Financed</option>
                                  <option value="Lease">Lease</option>
                                </Field>
                              </div>
                              <div className='form-group col-md-6'>
                                <div className='mb-4'>
                                  <div className='adr-label mb-1'>Lender</div>
                                  {!titleStatusEnabled.includes(values.titlestatus) ?
                                    <Field name="lender" type="text" className='form-control' disabled={!titleStatusEnabled.includes(values.titlestatus)} /> :
                                    <CustomAutoSearch filteredList={bankList} fieldName={"lender"} setFieldValue={setFieldValue} resetValue={autoSearchReset}/>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='modal-footer bg-lgray'>
                  <button className='blue-btn mxw-198 w-100 m-0 update-btn' type='submit'>Submit</button>
                </div>
              </Form>
            </>
          )}
        </Formik>
      </div>
    </>
  )
}

export default NewAppraisalModal